import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IUser, IUserRole } from 'modules/auth-session';

import { IUsersModal } from '../types/users.types';

export interface UsersState extends BaseDataReducerV2InitialState<IUser> {
  perPage: number;
  availableRoles: IUserRole[];
  selectedUser: IUser | null;
  editableUser: IUser | null;
  currentModal: IUsersModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IUser, UsersState>('app-users');

const usersState: UsersState = {
  ...initialState,
  perPage: 10,
  availableRoles: [],
  currentModal: null,
  selectedUser: null,
  editableUser: null,
};

export const users = createSlice({
  name: 'users',
  initialState: usersState,
  reducers: {
    setSelectedUser(state, action: PayloadAction<IUser | null>) {
      state.selectedUser = action.payload;
    },
    setAvailableRoles(state, action: PayloadAction<IUserRole[]>) {
      state.availableRoles = action.payload;
    },
    setUsersModal(state, action: PayloadAction<IUsersModal | null>) {
      state.currentModal = action.payload;
    },
    setEditableUser(state, action: PayloadAction<IUser | null>) {
      state.editableUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as UsersState, action);
    });
  },
});
export const UsersAC = AC;
export const onUsersSort = thunks.onSort;
export const onUsersFilter = thunks.onFilter;
export const clearUsersFilters = AC.clearFilters;
export const setUsersCurrentPage = AC.setCurrentPage;

export const { setAvailableRoles, setSelectedUser, setUsersModal, setEditableUser } = users.actions;
